import { useEffect, useState } from "react";
import { cartLineKey } from "./cartLineKey";
import { post } from "./api";

export default function useDeliveryQuote(items, addressId, enabled = true, refreshKey = 0) {
  const ids = JSON.stringify(
    items.map(cartLineKey).sort(),
  );
  const weights = JSON.stringify(items.map(item => [cartLineKey(item), item.quantity, item.weightGrams]).sort((a, b) => a[0].localeCompare(b[0])));
  const requestKey =
    enabled && addressId && items.length ? addressId + ":" + ids + ":" + weights + ":" + refreshKey : "";
  const [quote, setQuote] = useState({ key: "", fee: 0, error: "" });
  useEffect(() => {
    if (!requestKey) return;
    let cancelled = false;
    post("/orders/delivery-quote", {
      deliveryAddressId: addressId,
      selectedItems: JSON.parse(ids).map((key) => { const [productId, variantId] = key.split(':'); return { productId, variantId }; }),
    })
      .then((result) => {
        if (!cancelled)
          setQuote({ key: requestKey, fee: result.deliveryFee, routes: result.routes || [], error: "" });
      })
      .catch((error) => {
        if (!cancelled)
          setQuote({
            key: requestKey,
            fee: 0,
            error:
              error.response?.data?.message ||
              "Unable to calculate delivery fee.",
          });
      });
    return () => {
      cancelled = true;
    };
  }, [requestKey, addressId, ids]);
  return {
    routes: requestKey && quote.key === requestKey ? quote.routes || [] : [],
    deliveryFee: requestKey && quote.key === requestKey ? quote.fee : 0,
    quoteLoading: Boolean(requestKey && quote.key !== requestKey),
    quoteError: requestKey && quote.key === requestKey ? quote.error : "",
  };
}
